import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Cintillo, MasterBar, LoadingPlaceholder } from 'components';
import { isInsular } from 'utils';
import Town from '../town';
import MainRegional from './mainRegional';

import './home.scss';

import useResultProvider from '../../dataProvider/hooks/useResultProvider';
import useGetPlace from '../../dataProvider/hooks/useGetPlace';
import {
  getResultOrigin,
  useRESTDataCache,
  getPlace
} from '../../dataProvider';
import { SUBTYPES } from '../../envs';

import { PROPERTIES_JSON } from '../../core/constants';
import { NAVIGATION_MODE } from '../../constants';
import { getSite, isLaRazon } from '../../constants/sites';

const site = getSite();

const HomeRegional = ({ match, history }) => {
  const {
    allMap: allMapParams,
    chartType,
    community,
    country,
    electionNumber,
    navigableMode,
    province,
    showMasterBar,
    town,
    type,
    year
  } = match.params;

  const elSubtype =
    isInsular(province) && Boolean(town) ? SUBTYPES.INSULAR : SUBTYPES.SINGLE;

  const allMap = Boolean(Number(allMapParams));

  const params = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);

  const [mapData, setMapData] = useState([]);

  const [resultOrigin, setResultOrigin] = useState({});

  const [selectedTarget, setSelectedTarget] = useState(null);

  const [allRegions, setAllRegions] = useState([]);

  const { result: resultPartiesWinners } = useResultProvider({
    active: resultOrigin.primary?.active,
    year,
    type,
    subtype: SUBTYPES.SINGLE,
    electionPlace: community,
    electionNumber,
    details: Boolean(town),
    site,
    totals: true
  });

  const { result: dataResult } = useResultProvider({
    active: resultOrigin.primary?.active,
    year,
    type,
    subtype: elSubtype,
    electionPlace: community,
    electionNumber,
    placeId: town || province || community,
    details: Boolean(town),
    site
  });
  const { result: oldData } = useResultProvider({
    active: false /* buscame */,
    old: true,
    year: resultOrigin?.historic?.year,
    type,
    subtype: elSubtype,
    electionPlace: community,
    electionNumber: resultOrigin?.historic?.numElection,
    placeId: town || province || community
  });

  const { result: dataResultAutonomic } = useResultProvider({
    active: resultOrigin.primary?.active,
    year,
    type,
    subtype: SUBTYPES.AUTONOMIC,
    electionPlace: community,
    electionNumber,
    placeId: town || province || community,
    details: Boolean(town),
    site
  });
  const { result: oldDataResultAutonomic } = useResultProvider({
    active: false,
    year: resultOrigin?.historic?.year,

    type,
    subtype: SUBTYPES.AUTONOMIC,
    electionPlace: community,
    electionNumber,
    placeId: town || province || community,
    details: Boolean(town),
    site
  });

  const { result: dataResultInsular } = useResultProvider({
    active: resultOrigin.primary?.active,
    year,
    type,
    subtype: SUBTYPES.INSULAR,
    electionPlace: community,
    electionNumber,
    placeId: town || province || community,
    details: Boolean(town),
    site
  });

  const { result: oldDataResultInsular } = useResultProvider({
    active: false /* buscame */,
    year: resultOrigin?.historic?.year,
    old: true,
    type,
    subtype: SUBTYPES.INSULAR,
    electionPlace: community,
    electionNumber,
    placeId: town || province || community,
    details: Boolean(town),
    site
  });

  const selectedPlace = useGetPlace(town || province || community, type);
  const selectedCommunity = useGetPlace(community, type);
  const provincePlace = useGetPlace(province, type);

  // Este es el que dice donde tenemos que ir a buscar la info (si esta activo iremos a firebase si no amazon)
  // nos dice donde esta el historico que se consultara con amazon
  useEffect(() => {
    getResultOrigin(year, type, electionNumber, community)
      .then(_historicResult => {
        const historicResult = {
          ..._historicResult,
          primary: {
            ..._historicResult.primary
          }
        };
        setResultOrigin(historicResult);
      })
      .catch(err => {
        console.log(err);
      });

    getPlace({
      filter: 'typeplace=REGION&parentid=C108&size=1000',
      type,
      electionType: type
    }).then(regions => {
      setAllRegions(regions.content);
    });
  }, [year, type, electionNumber, community, country]);

  // este coge del Json de eleciones el target selecionado, se usa en el cintillo para poner el nombre de eleccion y la bandera
  useEffect(() => {
    if (params) {
      const selected = params.targets[type.toLowerCase()].find(
        tt => tt.ineId === community
      );
      setSelectedTarget(selected);
    }
  }, [community, params]);

  useEffect(() => {
    if (params) {
      if (params && !selectedTarget) {
        const selected = params.targets[type.toLowerCase()].find(
          tt => tt.ineId === community
        );
        setSelectedTarget(selected);
      }
      if (selectedTarget) {
        Promise.all([
          getPlace({
            filter: `typeplace=REGION&size=60`,
            type,
            electionType: type
          }), // provincias de españa
          getPlace({
            filter: `typeplace=PROVINCE&size=60`,
            type,
            electionType: type
          }), // provincias de españa
          getPlace({
            filter: `typeplace=TOWN&size=60&sortby=main`,
            type,
            electionType: type
          }) // capitales provincias de españa
        ]).then(([regions, provinces, provincesCapital]) => {
          const mappedProvinces = provinces.content.map(p => {
            const parent = regions.content.find(r => r.ineId === p.parentId);
            const capital = provincesCapital.content.find(
              c => c.parentId === p.ineId
            );
            return {
              ...p,
              community: parent,
              capital
            };
          });

          setMapData(mappedProvinces);
        });
      }
    }
  }, [
    community,
    electionNumber,
    navigableMode,
    type,
    year,
    params,
    selectedTarget
  ]);

  const onChangeLocation = (e, place, fromMap) => {
    const isL = isLaRazon(site);
    if (
      (parseInt(navigableMode, 10) === NAVIGATION_MODE.INTERNAL ||
        (allMap && fromMap)) &&
      !isL
    ) {
      e.preventDefault();

      switch (place.typePlace) {
        case 'PROVINCE':
          if (allMap) {
            history.push(
              `/${country}/${navigableMode}/${year}/REGIONAL/${electionNumber}/${chartType}/${showMasterBar}/0/${place.parentId}/home-regionales-resultados.html`
            );
          } else {
            history.push(
              `/${country}/${navigableMode}/${year}/REGIONAL/${electionNumber}/${chartType}/${showMasterBar}/0/${place.parentId}/${place.ineId}/home-regionales-resultados.html`
            );
          }
          break;
        case 'TOWN':
          history.push(
            `/${country}/${navigableMode}/${year}/REGIONAL/${electionNumber}/${chartType}/${showMasterBar}/0/${place.grandpaId}/${place.parentId}/${place.ineId}/home-regionales-resultados.html`
          );
          break;
        case 'REGION':
          history.push(
            `/${country}/${navigableMode}/${year}/REGIONAL/${electionNumber}/${chartType}/${showMasterBar}/0/${place.ineId}/home-regionales-resultados.html`
          );
          break;
        default:
          // go to home
          break;
      }
    }
  };
  if (
    !params ||
    !selectedTarget ||
    !dataResult ||
    !oldData ||
    !selectedCommunity ||
    resultPartiesWinners.length === 0 ||
    !selectedPlace ||
    !resultOrigin ||
    !allRegions ||
    !mapData
  ) {
    return <LoadingPlaceholder />;
  }

  return (
    <div
      className={`mainWrapper pageHome pageHome--regional chart_${chartType}`}
    >
      {resultOrigin && resultOrigin.primary ? (
        <div
          className={`block ${
            isInsular(province) || community === 'R05'
              ? dataResultInsular.currentCountPercent || `empty`
              : dataResult.currentCountPercent || `empty`
          }`}
        >
          <MasterBar params={params} history={history} match={match} />

          <Cintillo
            currentCountPercent={
              isInsular(province) || community === 'R05'
                ? dataResultInsular.currentCountPercent
                : dataResult.currentCountPercent
            }
            updateDate={
              isInsular(province) || community === 'R05'
                ? dataResultInsular.updateDate
                : dataResult.updateDate
            }
            withScrutiny
          />
          {town ? (
            <Town
              chartType={chartType}
              community={community}
              dataResult={dataResult}
              electionNumber={electionNumber}
              elSubtype={elSubtype}
              oldData={oldData}
              onChangeLocation={onChangeLocation}
              placeId={community}
              province={province}
              provincePlace={provincePlace}
              resultOrigin={resultOrigin}
              selectedCommunity={selectedCommunity}
              selectedPlace={selectedPlace}
              type={type}
              year={year}
            />
          ) : (
            <MainRegional
              allMap={allMap}
              allRegions={allRegions}
              chartType={chartType}
              community={community}
              country={country}
              dataResult={dataResult}
              electionNumber={electionNumber}
              elSubtype={elSubtype}
              mapData={mapData}
              oldData={oldData}
              onChangeLocation={onChangeLocation}
              partiesWinners={resultPartiesWinners}
              placeId={community}
              province={province}
              resultOrigin={resultOrigin}
              selectedCommunity={selectedCommunity}
              selectedPlace={selectedPlace}
              type={type}
              year={year}
              dataResultAutonomic={dataResultAutonomic}
              dataResultInsular={dataResultInsular}
              oldDataResultInsular={oldDataResultInsular}
              oldDataResultAutonomic={oldDataResultAutonomic}
            />
          )}
        </div>
      ) : (
        <LoadingPlaceholder />
      )}
    </div>
  );
};

HomeRegional.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      allMap: PropTypes.string,
      chartType: PropTypes.string.isRequired,
      community: PropTypes.string,
      country: PropTypes.string,
      electionNumber: PropTypes.string.isRequired,
      navigableMode: PropTypes.string.isRequired,
      province: PropTypes.string,
      showMasterBar: PropTypes.string,
      town: PropTypes.string,
      type: PropTypes.string.isRequired,
      year: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default HomeRegional;
